import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import VideoFeed from '../components/VideoFeed';
import { FaArrowLeft } from 'react-icons/fa';

const UserVideoFeed: React.FC = () => {
  const { userId } = useParams<{ userId: string }>();
  const [username, setUsername] = useState<string>('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    loadUserInfo();
  }, [userId]);

  const loadUserInfo = async () => {
    if (!userId) return;

    try {
      const { data: user, error } = await supabase
        .from('ponousers')
        .select('username, email')
        .eq('id', userId)
        .single();

      if (error) throw error;
      setUsername(user.username || user.email.split('@')[0]);
    } catch (error) {
      console.error('Error loading user info:', error);
    }
  };

  const handleBack = () => {
    // Check if we came from a specific page
    const from = location.state?.from;
    if (from) {
      navigate(from);
    } else {
      // Default to videoreel if no previous page
      navigate('/videoreel', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 bg-black bg-opacity-50 z-50 p-4">
        <div className="flex items-center">
          <button
            onClick={handleBack}
            className="text-white p-2 hover:bg-white hover:bg-opacity-10 rounded-full transition-colors"
          >
            <FaArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="ml-4 text-xl font-bold text-white">
            {username}'s Videos
          </h1>
        </div>
      </div>

      {/* Video Feed */}
      <div className="pt-16">
        <VideoFeed userId={userId} />
      </div>
    </div>
  );
};

export default UserVideoFeed;